/* Copyright 2013-2016 The MathWorks, Inc. */

/**
 * This defines a mapping between the type of control and the properties associated with it.
 * A property can be marked as required and a default value can also be assigned to it.
 */

define([
    "dojo/_base/lang",
    "../constants/TypeConstants",
    "MW/toolstrip/hashes/listOfNewWidgets"
], function (lang, TypeConstants, listOfNewWidgets) {
    var hash = {}, buttonProps, controlProps, listItemProps, dropDownProps;

    // Common properties:
    controlProps = {
        enabled: "disabled"
    };

    buttonProps = lang.mixin({
        text: "label"
    }, controlProps);

    listItemProps = lang.mixin({
        text: "label",
        showText: "showLabel",
        shortcut: "accelKey"
    }, controlProps);

    dropDownProps = lang.mixin({
        popupId: "menuId",
        hasDynamicPopup: "hasDynamicMenu"
    }, controlProps);

    // Buttons:
    hash[TypeConstants.PUSH_BUTTON] = listOfNewWidgets.indexOf(TypeConstants.PUSH_BUTTON) === -1 ? buttonProps : controlProps;

    hash[TypeConstants.TOGGLE_BUTTON] = lang.mixin({
            selected: "checked"
        }, listOfNewWidgets.indexOf(TypeConstants.TOGGLE_BUTTON) === -1 ? buttonProps : controlProps,
            listOfNewWidgets.indexOf(TypeConstants.TOGGLE_BUTTON) === -1 ? {} : {buttonGroupName: "buttonGroup"});

    hash[TypeConstants.TOGGLE_SPLIT_BUTTON] = lang.mixin({
            selected: "checked"
        }, listOfNewWidgets.indexOf(TypeConstants.TOGGLE_SPLIT_BUTTON) === -1 ? controlProps : dropDownProps,
            listOfNewWidgets.indexOf(TypeConstants.TOGGLE_SPLIT_BUTTON) === -1 ? {} : {buttonGroupName: "buttonGroup"},
            listOfNewWidgets.indexOf(TypeConstants.TOGGLE_SPLIT_BUTTON) === -1 ? {} : {dropDownAlwaysEnabled: "dropDownNeverDisabled"});

    hash[TypeConstants.DROP_DOWN_BUTTON] = listOfNewWidgets.indexOf(TypeConstants.DROP_DOWN_BUTTON) === -1 ? buttonProps : dropDownProps;

    hash[TypeConstants.SPLIT_BUTTON] = lang.mixin({}, listOfNewWidgets.indexOf(TypeConstants.SPLIT_BUTTON) === -1 ? buttonProps : dropDownProps,
            listOfNewWidgets.indexOf(TypeConstants.SPLIT_BUTTON) === -1 ? {} : {dropDownAlwaysEnabled: "dropDownNeverDisabled"});

    hash[TypeConstants.COLOR_PICKER_BUTTON] = controlProps;

    hash[TypeConstants.GRID_PICKER_BUTTON] = controlProps;

    //Special Controls:
    hash[TypeConstants.SPLIT_BUTTON_WITH_DISABLE_OVERRIDE] = buttonProps;

    // Popup lists:
    hash[TypeConstants.LIST_ITEM] = lang.mixin({}, listOfNewWidgets.indexOf(TypeConstants.LIST_ITEM) === -1 ? listItemProps : controlProps,
        listOfNewWidgets.indexOf(TypeConstants.LIST_ITEM) === -1 ? {} : { closePopupOnClick: "closeMenuOnClick" });

    hash[TypeConstants.LIST_ITEM_WITH_CHECKBOX] = lang.mixin({
            selected: "checked"
        }, listOfNewWidgets.indexOf(TypeConstants.LIST_ITEM_WITH_CHECKBOX) === -1 ? listItemProps : controlProps,
            listOfNewWidgets.indexOf(TypeConstants.LIST_ITEM_WITH_CHECKBOX) === -1 ? {} : {closePopupOnClick: "closeMenuOnClick"});

    hash[TypeConstants.LIST_ITEM_WITH_RADIO_BUTTON] = lang.mixin({
            selected: "checked"
        }, listOfNewWidgets.indexOf(TypeConstants.LIST_ITEM_WITH_RADIO_BUTTON) === -1 ? listItemProps : controlProps,
            listOfNewWidgets.indexOf(TypeConstants.LIST_ITEM_WITH_RADIO_BUTTON) === -1 ? {} : {closePopupOnClick: "closeMenuOnClick",
            buttonGroupName: "buttonGroup"});

    hash[TypeConstants.LIST_ITEM_WITH_TEXTFIELD] = lang.mixin(listOfNewWidgets.indexOf(TypeConstants.LIST_ITEM_WITH_TEXTFIELD) === -1 ? {editable: "readOnly"} : {placeholderText: "placeholder"}, {
        text: "value"}, {closePopupOnClick: "closeMenuOnClick"}, controlProps);

    hash[TypeConstants.LIST_ITEM_WITH_POPUP] = listOfNewWidgets.indexOf(TypeConstants.LIST_ITEM_WITH_POPUP) === -1 ? listItemProps : dropDownProps;

    hash[TypeConstants.POPUP_LIST_HEADER] = lang.mixin({
        title: listOfNewWidgets.indexOf(TypeConstants.POPUP_LIST_HEADER) === -1 ? "label" : "text"
    });

    hash[TypeConstants.SPINNER] = lang.mixin({
        minorStepSize: listOfNewWidgets.indexOf(TypeConstants.SPINNER) === -1 ? "smallDelta" : "step",
        majorStepSize: listOfNewWidgets.indexOf(TypeConstants.SPINNER) === -1 ? "largeDelta" : "step"
    }, listOfNewWidgets.indexOf(TypeConstants.SPINNER) === -1 ? {editable: "readOnly"} : {}, controlProps);

    hash[TypeConstants.TEXT_FIELD] = lang.mixin({
        text: "value"
    }, listOfNewWidgets.indexOf(TypeConstants.TEXT_FIELD) === -1 ? {placeholderText: "placeHolder_asdfasdf", editable: "readOnly"} : {placeholderText: "placeholder"}, controlProps);

    hash[TypeConstants.TEXT_AREA] = lang.mixin({
        text: "value"
    }, listOfNewWidgets.indexOf(TypeConstants.TEXT_AREA) === -1 ? {editable: "readOnly"} : {}, controlProps);

    hash[TypeConstants.RADIO_BUTTON] = lang.mixin(listOfNewWidgets.indexOf(TypeConstants.RADIO_BUTTON) === -1 ? {text: "label"} : {buttonGroupName: "buttonGroup"}, {
        selected: "checked"
    }, controlProps);

    hash[TypeConstants.LABEL] = lang.mixin({
    }, controlProps);

    hash[TypeConstants.CHECK_BOX] = lang.mixin(listOfNewWidgets.indexOf(TypeConstants.CHECK_BOX) === -1 ? {text: "label"} : {}, {
        selected: "checked"
    }, controlProps);

    hash[TypeConstants.COMBO_BOX] = lang.mixin(listOfNewWidgets.indexOf(TypeConstants.COMBO_BOX) === -1 ? { editable: "readOnly" } : {selectedItem: "value", placeholderText: "placeholder"}, controlProps);

    hash[TypeConstants.LIST] = lang.mixin(listOfNewWidgets.indexOf(TypeConstants.LIST) === -1 ? {} : {selectedItems: "value"}, controlProps);

    hash[TypeConstants.HORIZONTAL_SLIDER] = controlProps;

    hash[TypeConstants.GALLERY] = controlProps;
    hash[TypeConstants.GALLERY_ITEM] = controlProps;
    hash[TypeConstants.TOGGLE_GALLERY_ITEM] = lang.mixin({selected: "checked", buttonGroupName: "buttonGroup"}, controlProps);
    // QAB Controls:
    hash[TypeConstants.QAB_PUSH_BUTTON] = hash[TypeConstants.PUSH_BUTTON];
    hash[TypeConstants.QAB_DROP_DOWN_BUTTON] = hash[TypeConstants.DROP_DOWN_BUTTON];
    hash[TypeConstants.QAB_FLOATING_PANE_DOCK] = buttonProps;
    hash[TypeConstants.QAB_SPLIT_BUTTON] = hash[TypeConstants.SPLIT_BUTTON];
    hash[TypeConstants.QAB_TOGGLE_BUTTON] = hash[TypeConstants.TOGGLE_BUTTON];
    hash[TypeConstants.QAB_TOGGLE_SPLIT_BUTTON] = hash[TypeConstants.TOGGLE_SPLIT_BUTTON];

    Object.keys(hash).forEach(function (key) {
        Object.keys(hash[key]).forEach(function (prop) {
            hash[key][hash[key][prop]] = prop;
        });
    });

    return hash;
});
